var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5h-7c-2.553 0-4 1.447-4 4v7c0 2.547 1.44 4 4 4h7c2.553 0 4-1.453 4-4v-7c0-2.553-1.447-4-4-4z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.562 9.531v1.912A.56.56 0 0 1 9 12a.56.56 0 0 1-.562-.557V9.53H6.51a.565.565 0 0 1-.51-.56c0-.289.22-.53.51-.56h1.922V6.505A.566.566 0 0 1 8.997 6c.291 0 .535.218.565.505v1.906h1.928c.29.03.51.271.51.56 0 .289-.22.53-.51.56H9.562z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.5,
    y1: 1.5,
    x2: 1.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1080FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcAdd);
export default __webpack_public_path__ + "static/media/icon-ic-add.862c94a5.svg";
export { ForwardRef as ReactComponent };